import * as actionTypes from "../constants/cartConstants";

import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';

import axios from "axios";

import store from "../store";

const getCartItems = () => async (dispatch, getState) => {
  try {
    const { cart } = getState();
   
    // Check if cart items have already been fetched
    if (cart.fetchedCartItems) {
      return;
    }

    dispatch({ type: actionTypes.ADD_TO_CART_REQUEST });
    

    const token = Cookies.get("uaTfl");
    const guc = Cookies.get("_guc");
    const cId = Cookies.get("cId");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
      const res = await axios.post(`/api/v1/cart/getCartItems`, {}, { headers });
      // console.log('getCartItems response:', res.data); // added logging here

      if (res.status === 200) {
        const { cartItems, priceDetails, totalItems } = res.data;
        dispatch({
          type: actionTypes.ADD_TO_CART_SUCCESS,
          payload: { cartItems, priceDetails, totalItems, fetchedCartItems: true },
        });
      }
    } else if (guc && cId) {
      const res = await axios.post(`/api/v1/cart/getGuCartItems`, { guc, cId });
      // console.log('getGuCartItems response:', res.data); // added logging here

      if (res.status === 200) {
        const { cartItems, priceDetails, totalItems } = res.data;
        dispatch({
          type: actionTypes.ADD_TO_CART_SUCCESS,
          payload: { cartItems, priceDetails, totalItems, fetchedCartItems: true },
        });
      }
    } else {
      // Handle case where user is not logged in and cookies are missing
    }
  } catch (error) {
    console.log(error);
  }
};

// export const addToCart = (product, newQty = 1) => async (dispatch) => {
//     const {
//       cart: { cartItems },
//       user,
//     } = store.getState();
//     //console.log('action::products', products);
//     //const product = action.payload.product;
//     //const products = state.products;
//     const qty = cartItems[product._id]
//       ? parseInt(cartItems[product._id].qty + newQty)
//       : 1;
//     cartItems[product._id] = {
//       ...product,
//       qty,
//     };

//     if (user.isAuthenticated) {
//       dispatch({ type: actionTypes.ADD_TO_CART_REQUEST });

//       const payload = {

//         cartItems: [
//           {
//             product: product._id,
//             quantity: qty,
//           },
//         ],
//       };

//       const res = await axios.post(`/api/v1/cart/add-to-cart`, payload);
//       if (res.status === 201) {
//         dispatch(getCartItems());
//       }
//     } else {
//       localStorage.setItem("guc", JSON.stringify(cartItems));
//     } 

//     dispatch({
//       type: actionTypes.ADD_TO_CART_SUCCESS,
//       payload: { cartItems },
//     });
//   };



export const addToCart = (product, newQty = 1) => async (dispatch, getState) => {
  const { cart: { cartItems }, user } = getState();
  const qty = cartItems[product._id] ? parseInt(cartItems[product._id].qty + newQty) : 1;
  cartItems[product._id] = {
    ...product,
    qty,
  };

  return new Promise(async (resolve, reject) => {
    if (user.isLoggedIn) {
      dispatch({ type: actionTypes.ADD_TO_CART_REQUEST });
      const payload = {
        cartItems: [
          {
            product: product._id,
            quantity: qty,
          },
        ],
      };

      const token = Cookies.get("uaTfl");
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      try {
        const { data } = await axios.post(`/api/v1/cart/add-to-cart`, payload, headers);
        dispatch(getCartItems());
        dispatch({ type: actionTypes.ADD_TO_CART_SUCCESS, payload: data });
        resolve(data); // Resolve with the response data
      } catch (error) {
        dispatch({ type: actionTypes.ADD_TO_CART_FAIL, payload: error.message });
        reject(error); // Reject with the error
      }
    } else {
      try {
        const { data } = await axios.post('/api/v1/cart/gu-cart', { cartItems });
        if (data.cartId) {
          const existingCartId = Cookies.get('cId');
          const existingCartHash = Cookies.get(`_guc-${existingCartId}`);
          Cookies.remove(`_guc-${existingCartId}`);
          Cookies.set(`_guc-${data.cartId}`, data.cartHash);
          Cookies.set('cId', data.cartId);

          // Update the cartItems object with new quantity
          if (cartItems[product._id]) {
            cartItems[product._id].qty += newQty;
          } else {
            cartItems[product._id] = {
              ...product,
              qty: newQty,
            };
          }

          dispatch({ type: actionTypes.ADD_TO_CART_SUCCESS, payload: { cartItems } });
          resolve(data); // Resolve with the response data
        } else {
          throw new Error('Invalid cart ID received from the server');
        }
      } catch (error) {
        dispatch({ type: actionTypes.ADD_TO_CART_FAIL, payload: error.message });
        reject(error); // Reject with the error
      }
    }
  });
};




// export const removeCartIte = (productId) => {
//   return async (dispatch) => {
//     try {
//       dispatch({ type: actionTypes.REMOVE_CART_ITEM_REQUEST });
//       const token = Cookies.get("uaTfl");
//       const headers = {};
//       if (!token) {
//         throw new Error('User not logged in!');
//       }
//       headers.Authorization = `Bearer ${token}`;
//       const res = await axios.post(`/api/v1/cart/removeItem/${productId}`, {}, { headers } );
//       if (res.status === 200) {
//         dispatch({ type: actionTypes.REMOVE_CART_ITEM_SUCCESS });
//         dispatch(getCartItems());
//       } else {
//         const { error } = res.data;
//         dispatch({
//           type: actionTypes.REMOVE_CART_ITEM_FAIL,
//           payload: { error },
//         });
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
// };

export const removeCartItem = (productId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: actionTypes.REMOVE_CART_ITEM_REQUEST });
      const token = Cookies.get("uaTfl");
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      if (token) {
        const res = await axios.post(`/api/v1/cart/removeItem/${productId}`, headers);
        if (res.status === 200) {
          const { cart } = res.data;
          dispatch({ type: actionTypes.REMOVE_CART_ITEM_SUCCESS, payload: { cart } });
        } else {
          const { error } = res.data;
          dispatch({
            type: actionTypes.REMOVE_CART_ITEM_FAIL,
            payload: { error },
          });
        }
      } else {
        // User is not logged in, remove the cart item from the cookie
        const res = await axios.post(`/api/v1/cart/removeGuCartItem/${productId}`);
        if (res.status === 200) {
          const { cart } = res.data;
          dispatch({ type: actionTypes.REMOVE_CART_ITEM_SUCCESS, payload: { cart } });
        } else {
          const { error } = res.data;
          dispatch({
            type: actionTypes.REMOVE_CART_ITEM_FAIL,
            payload: { error },
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
};


export const updateCart = () => {
  return async (dispatch) => {
    const { user } = store.getState();
    const cartItems = Cookies.get("_guc") ? JSON.parse(atob(Cookies.get("_guc"))) : null;
    if (user.isLoggedIn) {
      Cookies.remove("_guc");
      Cookies.remove("cId");
      if (cartItems && Object.keys(cartItems).length > 0) {
        const payload = {
          cartItems: Object.values(cartItems).map((item) => ({
            quantity: item.qty,
            product: item._id,
          })),
        };
        const token = Cookies.get("uaTfl");
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
        const res = await axios.post(`/api/v1/cart/add-to-cart`, payload, headers);
        if (res.status === 201) {
          dispatch(getCartItems());
        }
      } else {
        dispatch(getCartItems());
      }
    } else if (cartItems) {
      dispatch({
        type: actionTypes.ADD_TO_CART_SUCCESS,
        payload: { cartItems },
      });
    }
  };
};

export {
  getCartItems
}

export const addCartItemsToPersist = (cartItems) => async (dispatch) => {
  try {
    const { data } = await axios.post('/api/v1/cart/save-temp-cart', { cartItems });
    const { token } = data;

    // Store the token in sessionStorage
    sessionStorage.setItem('cData', token);

    // Dispatch success action with the updated cart items
    dispatch({ type: 'CART_ITEMS_PERSISTED', payload: cartItems });
  } catch (error) {
    // Dispatch failure action with error message
    dispatch({ type: 'CART_PERSIST_ERROR', payload: error.message });
  }
};



